import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { WhatsappLogo } from "@phosphor-icons/react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * FAB de WhatsApp visible en Landing, Eventos, Detalle de Evento y Tienda.
 * Se oculta en el panel /admin y /login para no ensuciar la UI.
 * Usa el número que el admin configura en /api/contact-info.
 * Adapta el mensaje pre-cargado según la página donde el usuario esté.
 */
export default function WhatsAppFab() {
  const [phone, setPhone] = useState("");
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/contact-info`).then(res => {
      if (cancelled) return;
      const wa = (res.data?.whatsapp || "").replace(/[^\d+]/g, "");
      setPhone(wa.replace(/^\+/, ""));
    }).catch(() => {});
    return () => { cancelled = true; };
  }, []);

  // Ocultar FAB en admin y login
  if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/login")) return null;
  if (!phone) return null;

  // Mensaje contextual según ruta
  const contextMsg = (() => {
    const p = location.pathname;
    if (p.startsWith("/eventos/")) return "Hola! Me gustaría más información sobre este evento";
    if (p.startsWith("/eventos")) return "Hola! Me interesa participar en un evento";
    if (p.startsWith("/entrenamientos/")) return "Hola! Me gustaría más información sobre este plan de entrenamiento";
    if (p.startsWith("/entrenamientos")) return "Hola! Me interesa un plan de entrenamiento";
    if (p.startsWith("/tienda")) return "Hola! Tengo una consulta sobre un producto";
    return "Hola! Me gustaría consultar sobre Pro Vertical";
  })();

  const href = `https://wa.me/${phone}?text=${encodeURIComponent(contextMsg)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed z-40 bottom-5 right-5 sm:bottom-6 sm:right-6 flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] hover:bg-[#1DAB53] text-white rounded-full shadow-xl shadow-black/40 transition-transform duration-300 hover:scale-110 active:scale-95 group"
      style={{ touchAction: "manipulation" }}
    >
      {/* Pulso animado detrás del icono */}
      <span
        className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping"
        style={{ animationDuration: "2.4s" }}
        aria-hidden="true"
      />
      <WhatsappLogo size={30} weight="fill" className="relative z-10" />
      <span className="hidden sm:block absolute right-full mr-3 whitespace-nowrap bg-black/80 text-white text-xs px-3 py-1.5 rounded font-medium opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Contáctanos
      </span>
    </a>
  );
}
